import React, { useEffect } from "react";

import getAccessToken from './helpers/getAccessToken.js';
import { DISCORD_API_URL } from './globals.js';

const OAuth2Handler = () => {

  useEffect(() => {
    // typical URL: http://localhost:7772/oauth2/callback/#token_type=Bearer&access_token=FG2Jq8auzDIgwHddsYiyy3kLAZ3mjG&expires_in=604800&scope=identify

    const currentPath = window.location.pathname;
    const currentRoute = currentPath.replace(/^\/\d+\.\d+\.\d+\.\d+:\d+/, '');

    if (currentRoute !== "/oauth2/callback/") { return; }

    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const discordToken = hashParams.get('access_token');

    // Preserve local chardata across the redirect (existing behavior).
    const chardata = localStorage.getItem('char0data');
    if (chardata) localStorage.setItem('chardata-stored', chardata);

    const finish = () => {
        // Full reload so App runs session-check and picks up the new httpOnly cookie.
        window.location.href = '/';
    };

    if (!discordToken) {
        finish();
        return;
    }

    (async () => {
        try {
            // Fetch Discord user info from the browser (not via Lambda proxy).
            const discordRes = await fetch(DISCORD_API_URL, {
                headers: { Authorization: `Bearer ${discordToken}` }
            });
            if (!discordRes.ok) throw new Error('Discord /users/@me failed: ' + discordRes.status);
            const discordUser = await discordRes.json();

            await getAccessToken(discordToken, discordUser);
        } catch (err) {
            console.error('OAuth2 token exchange failed:', err);
        } finally {
            finish();
        }
    })();
  }, []);

  return (
    <div id="OAuth2" style={{ width: '450px' }}>
      Discord login confirmed, restarting app...
    </div>
  );
};

export default OAuth2Handler;
